module.exports = __webpack_public_path__ + "static/ProximaNova-Regular-390506172d5564ef86cc074ffe6a2506.woff";